import { actionCreatorFactory } from 'typescript-fsa';
import type { IApiErrorParams } from '@cbridge-packages/api';
import type { IExposureSymbol, IExposureDetails } from './exposure.interface';

export namespace ExposureAction {
  const actionCreator = actionCreatorFactory('Exposure');

  export const loadSymbolList = actionCreator.async<
    { symbolGroup?: string; asset?: string; includeUnits?: boolean },
    IExposureSymbol[],
    IApiErrorParams
  >('LOAD_SYMBOL_LIST');
  export const loadDetails = actionCreator.async<
    { symbolId?: IExposureSymbol['id']; symbolGroup?: string; asset?: string },
    IExposureDetails,
    IApiErrorParams
  >('LOAD_DETAILS');

  export const destroy = actionCreator('DESTROY');
}
